import { Action } from '@openfin/predux';
import { injectable, inject } from 'inversify';
import { Inject } from '../common/Injectables';
import { Frame } from '../model/Frame';
import { WebWindowFactory } from '../model/WebWindow';
import { OpenFrame } from '../store/partials/Frames';
import { ServiceStore } from '../store/ServiceStore';
import { RootState } from '../store/State';

/**
 * Translates store actions to events to be dispatched to the client.
 */
@injectable()
export class FrameManager {
  private readonly _frames = new Map<string, Frame>();
  constructor(
    @inject(Inject.STORE) public readonly store: ServiceStore,
    @inject(Inject.WEB_WINDOW_FACTORY) private readonly webWindowFactory: WebWindowFactory
  ) {
    this.store.onAction.add(
      async (action: Action<RootState>): Promise<void> => {
        if (action instanceof OpenFrame) {
          this.createFrame(action.key, action.isStream);
        }
      }
    );

    Object.assign(window, { frameManager: this });
  }

  public createFrame(key: string, isStream: boolean): void {
    const frame = new Frame(this.webWindowFactory, this.store, key, isStream, () => {
      this._frames.delete(key);
    });
    this._frames.set(frame.frameId, frame);
  }

  public async destoryFrame(id: string): Promise<void> {
    await this._frames.get(id)?.destroy();
  }
}
